// Formats a user role string like "Production_Coordinator" to "Production Coordinator"
export function formatRole(role) {
  if (!role || typeof role !== "string") return "";
  // Replace underscores with spaces and capitalize each word
  return role
    .replace(/_/g, " ")
    .replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
}

export function formatKeyWord(word) {
  if (!word || typeof word !== "string") return "";
  // Replace underscores with spaces and capitalize each word
  return word
    .replace(/_/g, " ")
    .replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
}

export function toCamelCase(input) {
  return input
    .replace(/[^a-zA-Z0-9 ]+/g, "") // Remove special characters
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase()
    )
    .replace(/\s+/g, "");
}

export function capitalizeFirstLetter(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
